/** LocalStorage keys + navigation constants */
import { buildNavGroups, PUBLIC_ROUTE_IDS, ROUTE_ALIASES, ROUTE_REDIRECT_REGISTRY, ROUTES } from "../routes/manifest.js";

export const LS = {
  token: "croc.token",
  user: "croc.user",
  role: "croc.role",
  zones: "croc.zones",
  theme: "croc.theme",
  sidebarCollapsed: "croc.sidebar.collapsed",
};

/** One-time: drop legacy JWT in localStorage; session uses HttpOnly cookie when API omits access_token. */
try {
  const _m = "croc.auth.migrate_cookie_v1";
  if (!localStorage.getItem(_m)) {
    localStorage.removeItem(LS.token);
    localStorage.setItem(_m, "1");
  }
} catch (_) {}

/** Match server ``OFFLINE_THRESHOLD_SECONDS`` default (120s) when ``is_online`` is absent. */
export const OFFLINE_MS = 120 * 1000;
/** Default remote siren / group loud duration (1 min); matches server `DEFAULT_REMOTE_FANOUT_MS`. */
export const DEFAULT_REMOTE_SIREN_MS = 60000;
/** Panic sibling fan-out default (1 min); matches server `DEFAULT_PANIC_FANOUT_MS`. */
export const DEFAULT_PANIC_FANOUT_MS = 60000;
/** Default local siren (`sir_ms`) when operator sets device default — same 1 min baseline as server fan-out. */
export const DEFAULT_LOCAL_SIREN_MS = 60000;

/** Sidebar groups derived from the canonical route manifest. Anyone modifying
 * navigation entries should edit src/routes/manifest.js, not this file. */
export const NAV_GROUPS = buildNavGroups();

export { PUBLIC_ROUTE_IDS, ROUTE_ALIASES, ROUTE_REDIRECT_REGISTRY, ROUTES };

export const ROLE_WEIGHT = { user: 1, admin: 2, sa_staff: 2, superadmin: 3 };
